import { Box, Stack } from '@mui/material';

import { StickyNoteToolbarFontSelect } from './Font';
import { type ReactFlowStickyNoteNodeProps } from '../../BlockType/types';
import { DecorationColorMenu } from '../../Decorations/Toolbar/ColorMenu';
import { DeleteDecorationToolbarButton } from '../../Decorations/Toolbar/DeleteButton';

export function StickyNoteToolbar(props: ReactFlowStickyNoteNodeProps) {
  const { id: nodeId, selected, data } = props;
  return (
    <Box
      sx={{
        display: selected ? 'block' : 'none',
        position: 'absolute',
        top: -48,
        right: 0,
        paddingX: 1,
        backgroundColor: 'background.paper',
        borderRadius: 2,
        boxShadow: 1,
      }}
      className={selected ? 'nodrag' : undefined} // Blocks dragging the card when not selected
    >
      <Stack direction="row" gap={1} justifyContent="space-between" alignItems="center">
        <DecorationColorMenu nodeId={nodeId} color={data.color} />
        <StickyNoteToolbarFontSelect {...props} />
        <DeleteDecorationToolbarButton nodeId={nodeId} />
      </Stack>
    </Box>
  );
}
